<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <div class="header-actions">
      <i class="fa fa-times" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body">

    <!-- Pill tabs -->
    <ul class="ba-tab ba-tab-pills">
      <li (click)="activeTabIndex = 0"
          (mouseenter)="tabHoverGrid = true" (mouseleave)="tabHoverGrid = false">
        <a [ngClass]="{'ba-activeTab': activeTabIndex === 0, 'ba-inactiveTab': activeTabIndex !== 0 && tabHoverGrid}">Grid Action</a>
      </li>
      <li (click)="activeTabIndex = 1"
          (mouseenter)="tabHoverScreen = true" (mouseleave)="tabHoverScreen = false">
        <a [ngClass]="{'ba-activeTab': activeTabIndex === 1, 'ba-inactiveTab': activeTabIndex !== 1 && tabHoverScreen}">Screen Modal</a>
      </li>
    </ul>

    <!-- Tab 1: Grid Action -->
    @if (activeTabIndex === 0) {
<div class="ba-tab-content">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label>Grid Key:</label>
            <input type="text" class="form-control" [value]="gridKey" disabled>
          </div>

          @if (gridActionData.grid_action_key) {
<div class="form-group">
            <label>Grid Action Key:</label>
            <input type="text" class="form-control" [value]="gridActionData.grid_action_key" disabled>
          </div>
}

          <div class="form-group">
            <label>Action Name:</label>
            <input type="text" class="form-control" [(ngModel)]="gridActionData.actionName"
                   name="ba_action_name">
          </div>

          <div class="form-group">
            <label>Icon:</label>
            <input type="text" class="form-control" [(ngModel)]="gridActionData.icon"
                   name="ba_icon">
          </div>

          <div class="form-group">
            <label>Raw Data Required:</label>
            <input type="text" class="form-control" [(ngModel)]="gridActionData.rawDataReq"
                   name="ba_raw_data">
          </div>
        </div>

        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label>Call Back Name:</label>
            @if (callBackLoading) {
<div style="text-align: center; padding: 8px;">
              <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: #e12827;"></i>
            </div>
}
            @if (!callBackLoading) {
<ap-dropdown class="field-full-width" [list]="callBackDropdownItems" [selectType]="'single'"
                        [title]="'Call Back Name'" [hideTitleOnInput]="true" [inputAriaLabel]="'Call Back Name'"
                        [showSearchbox]="true"
                        [(ngModel)]="selectedCallBackItem" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onCallBackDropdownSelect($event)" name="ba_callback">
            @for (item of callBackDropdownItems; track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'Call Back Name')"
                (onSelectItem)="onCallBackSelectItem($event)"></ap-dropdown-list-item>
            }
            </ap-dropdown>
}
          </div>
        </div>
      </div>
    </div>
}

    <!-- Tab 2: Screen Modal -->
    @if (activeTabIndex === 1) {
<div class="ba-tab-content">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label>Client Key:</label>
            <input type="text" class="form-control" [value]="clientKey" disabled>
          </div>

          @if (gridScreenData.screen_modal_key) {
<div class="form-group">
            <label>Screen Modal Key:</label>
            <input type="text" class="form-control" [value]="gridScreenData.screen_modal_key" disabled>
          </div>
}

          <div class="form-group">
            <label>Modal Name:</label>
            <input type="text" class="form-control" [(ngModel)]="gridScreenData.modal_name"
                   name="sm_modal_name">
          </div>

          <div class="form-group">
            <label>Modal Size:</label>
            <input type="text" class="form-control" [(ngModel)]="gridScreenData.modal_size"
                   name="sm_modal_size">
          </div>

          <div class="form-group">
            <label>Template Path:</label>
            <input type="text" class="form-control" [(ngModel)]="gridScreenData.template_path"
                   name="sm_template_path">
          </div>
        </div>

        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label>Controller Path:</label>
            <input type="text" class="form-control" [(ngModel)]="gridScreenData.controller_path"
                   name="sm_controller_path">
          </div>

          <div class="form-group">
            <label>Modal Css Path:</label>
            <input type="text" class="form-control" [(ngModel)]="gridScreenData.modal_css_path"
                   name="sm_css_path">
          </div>

          <div class="form-group">
            <label>Modal lock:</label>
            <select class="form-control" [(ngModel)]="gridScreenData.is_locked"
                    name="sm_is_locked">
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>

          <div class="form-group">
            <label>Modal Description:</label>
            <textarea class="form-control" placeholder="Enter Description Here..."
                      [(ngModel)]="gridScreenData.modal_desc"
                      name="sm_modal_desc"></textarea>
          </div>
        </div>
      </div>
    </div>
}

  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="saving">
      Save @if (saving) {
<i class="fa fa-spinner fa-spin"></i>
}
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
